/**
 * Tracks the pathname visited immediately before the current one, within this
 * SPA session — browser APIs can't tell you what the previous history entry's
 * URL was, so we record it ourselves as React Router navigates.
 *
 * Usage: mount <NavigationHistoryTracker /> once, near the router root, then
 * call getPreviousPathname() anywhere to see what path preceded the current one.
 */
let previousPathname = null;
let currentPathname = null;

export function getPreviousPathname() {
    return previousPathname;
}

export function recordPathname(pathname) {
    if (pathname === currentPathname) return;
    previousPathname = currentPathname;
    currentPathname = pathname;
}
